export {
  SEMRESATTRS_DEPLOYMENT_ENVIRONMENT,
  SEMRESATTRS_SERVICE_NAME,
  SEMRESATTRS_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions';

export const ATTRS_SPLIT_ID = 'split.id';
export const ATTRS_USER_ID = 'user.id';
export const ATTRS_ERROR_MESSAGE = 'error.message';
export const ATTRS_WEB_REVALIDATION_PATHNAME = 'web.revalidation.pathname';
